/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Custom informative icon representing an unsuccessful experiment.
 * @export
 */
export const ICON_EXPERIMENTS_LIST_EMPTY = (
  <svg fill="none" height="177" viewBox="0 0 172 177" width="172" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 86.5C0 39.0035 38.5035 0.5 86 0.5C133.496 0.5 172 39.0035 172 86.5V150.263C172 164.753 160.253 176.5 145.763 176.5H88C39.3989 176.5 0 137.101 0 88.5V86.5Z"
      fill="#F5F5F5"
    />
    <rect fill="#057E91" height="100" rx="50" width="100" x="36" y="32.5" />
    <path
      d="M81.3333 61.5H69.6667C67.1 61.5 65 63.6 65 66.1667V98.8334C65 101.4 67.1 103.5 69.6667 103.5H81.3333V105.833C81.3333 107.117 82.3833 108.167 83.6667 108.167C84.95 108.167 86 107.117 86 105.833V59.1667C86 57.8834 84.95 56.8334 83.6667 56.8334C82.3833 56.8334 81.3333 57.8834 81.3333 59.1667V61.5ZM81.3333 96.5H69.6667L81.3333 82.5V96.5ZM102.333 61.5H90.6667V66.1667H100C101.283 66.1667 102.333 67.2167 102.333 68.5V96.5L90.6667 82.5V103.5H102.333C104.9 103.5 107 101.4 107 98.8334V66.1667C107 63.6 104.9 61.5 102.333 61.5Z"
      fill="white"
    />
    <rect fill="#F5F5F5" height="56" rx="28" width="56" x="104" y="104.5" />
    <path
      clipRule="evenodd"
      d="M108.667 132.5C108.667 119.597 119.097 109.167 132 109.167C144.904 109.167 155.334 119.597 155.334 132.5C155.334 145.403 144.904 155.833 132 155.833C119.097 155.833 108.667 145.403 108.667 132.5ZM138.744 142.533C139.654 143.443 141.124 143.443 142.034 142.533C142.92 141.623 142.92 140.13 142.034 139.243L135.29 132.5L142.034 125.757C142.944 124.847 142.944 123.377 142.034 122.467C141.124 121.557 139.654 121.557 138.744 122.467L132 129.21L125.257 122.467C124.347 121.557 122.877 121.557 121.967 122.467C121.53 122.903 121.285 123.494 121.285 124.112C121.285 124.729 121.53 125.321 121.967 125.757L128.71 132.5L121.967 139.243C121.53 139.679 121.285 140.271 121.285 140.888C121.285 141.506 121.53 142.097 121.967 142.533C122.877 143.443 124.347 143.443 125.257 142.533L132 135.79L138.744 142.533Z"
      fill="#BABABA"
      fillRule="evenodd"
    />
  </svg>
);
